import {createUserWithEmailAndPassword} from "firebase/auth";
import React,  { useState } from 'react'
import { auth } from '../Firebase/firebaseConfig/firebase';
import { Link } from "react-router-dom"
import '../../style/Login.css'
import Swal from 'sweetalert2';
import withReactContent from 'sweetalert2-react-content';
const MySwal = withReactContent(Swal);


const SignUp = () => {

const [email, setEmail] = useState("");
const [password, setPassword] = useState("");

const signUp = (e) =>{
    e.preventDefault();
    createUserWithEmailAndPassword(auth, email, password)
    .then((userCredential)=>{
		Swal.fire({
			icon: "success",
			text: "Usuario registrado con éxito.",
		});
    console.log(userCredential);
    }).catch((error)=>{
			Swal.fire({
				icon: "error",
				text: "Error al registrarse.",
			});
    console.log(error);
    })
}
return (
    <div className='container mx-auto bg-light' style={{ maxWidth: '400px' }} id='login-form'>
        <form onSubmit={signUp}>
            <h2 className="card-title text-center mt-3">Registro</h2>        
            <input type="email" className='form-control mt-5 col-sm-6' placeholder='Ingrese su email' 
            value={email} onChange={(e)=> setEmail(e.target.value)}/>
            <input type="password" className='form-control mt-3 col-sm-6' placeholder='Ingrese su contraseña' 
            value={password} onChange={(e)=> setPassword(e.target.value)}/>
            <button className="btn btn-info text-light mt-3" style={{ width: '100%' }} type='submit'>Registrarse</button>
            <p className="login-text">Ya posee una cuenta? <Link to = "/Login"> Login </Link></p>            
        </form>
    </div>
)}

export default SignUp;